/**
 * AUTO-GENERATED by agent-contracts-runtime. DO NOT EDIT.
 *
 * Regenerate via: npx agent-runtime generate
 */

import type { AgentId } from "./agents";
import type { HandoffTypeId } from "./handoffs";

export type ModelClass = "fast" | "standard" | "thinking";

export interface TaskContract {
  readonly id: string;
  readonly description: string;
  readonly target_agent: AgentId;
  readonly allowed_from_agents: readonly AgentId[];
  readonly workflow: string;
  readonly invocation_handoff: HandoffTypeId;
  readonly result_handoff: HandoffTypeId;
  readonly input_artifacts: readonly string[];
  readonly responsibilities: readonly string[];
  readonly completion_criteria: readonly string[];
  readonly optional: boolean;
  readonly model_class?: ModelClass;
}

export const auditLitedbmodelUsage: TaskContract = {
  id: "audit-litedbmodel-usage",
  description: "Audit TypeScript source files that import or use litedbmodel model classes. Detect the eight canonical anti-patterns (LOOP_CREATE, DELETE_REINSERT, MISSING_IDEMPOTENCY, AGGREGATE_SKIP, OVER_DELETE, MISSING_LOCK, UNIQUE_MISSING, N_PLUS_ONE) and return structured findings with severity ratings and remediation guidance referencing the correct litedbmodel API.",
  target_agent: "litedbmodel-auditor",
  allowed_from_agents: [
  "litedbmodel-auditor"
],
  workflow: "audit-workflow",
  invocation_handoff: "litedbmodel-audit-request",
  result_handoff: "litedbmodel-audit-result",
  input_artifacts: [],
  responsibilities: [
  "Parse the provided source code for litedbmodel model import sites and all subsequent usages.",
  "Classify each usage occurrence against the eight anti-pattern categories.",
  "Return findings conforming to the litedbmodel-audit-result schema."
],
  completion_criteria: [
  "All litedbmodel usage sites in the provided code have been inspected.",
  "The findings array is populated (may be empty when no issues are found).",
  "The riskLevel field reflects the highest-severity finding present.",
  "Each finding with severity >= warning includes a recommendation field referencing the correct litedbmodel API method."
],
  optional: false,
  model_class: "standard",
};

export const implementLitedbmodelFeature: TaskContract = {
  id: "implement-litedbmodel-feature",
  description: "Implement a litedbmodel-based business feature by reading model definitions and writing TypeScript code directly to the target file. The agent uses file tools (Glob, Read, Edit, Write) to operate on the user's project, proactively avoiding all eight litedbmodel anti-patterns.",
  target_agent: "litedbmodel-implementer",
  allowed_from_agents: [
  "litedbmodel-implementer"
],
  workflow: "implement-workflow",
  invocation_handoff: "litedbmodel-implement-request",
  result_handoff: "litedbmodel-implement-result",
  input_artifacts: [],
  responsibilities: [
  "Parse the feature description to identify the required data operations.",
  "Read model definition files using Glob + Read to understand available models, columns, and constraints.",
  "Read the target file to understand its current state.",
  "Write the implementation to the target file using Edit or Write tools.",
  "Apply best-practice patterns proactively (createMany, upsert, forUpdate, transaction) so that no anti-pattern appears in the written code.",
  "Report what was changed in the changedFiles array."
],
  completion_criteria: [
  "The target file has been modified on disk via file tools.",
  "Written code uses only documented litedbmodel API methods.",
  "None of the eight anti-patterns appear in the written code.",
  "The changedFiles array lists every file that was created or updated.",
  "If schema context is insufficient, missing information is listed in the findings array and the agent stops."
],
  optional: false,
  model_class: "thinking",
};

export const taskRegistry: Record<string, TaskContract> = {
  "audit-litedbmodel-usage": auditLitedbmodelUsage,
  "implement-litedbmodel-feature": implementLitedbmodelFeature,
};
